<script lang="ts" setup>
import LoaderOverlay from '@sigma/ui/LoaderOverlay.vue';
</script>

<template>
  <div :class="css.layout">
    <ClientOnly>
      <slot />
      <template #fallback>
        <LoaderOverlay />
      </template>
    </ClientOnly>
  </div>
</template>

<style lang="scss" module="css">
.layout {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  background: $color-white;
}
</style>
